// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DataTable_table__5hksv {
  border-collapse: separate;
  border-spacing: 0 5px;
}
.DataTable_table__5hksv .DataTable_tableRow__PW3q2 {
  position: relative;
  height: 53px;
  background-color: #fff;
}
.DataTable_table__5hksv .DataTable_tableRow__PW3q2 > td {
  position: relative;
  z-index: 1;
}
.DataTable_table__5hksv .DataTable_tableRow__PW3q2 > td > a {
  position: relative;
}
.DataTable_table__5hksv .DataTable_tableRow__PW3q2:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  border: 1px solid var(--border);
  border-radius: 10px;
}

.DataTable_tableRow2__iCh4z > td:first-child:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  border-radius: 10px;
  background-color: var(--addition-7);
  opacity: 0.05;
  z-index: -1;
}
.DataTable_tableRow2__iCh4z > td > a {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/Common/UI/DataTable/index.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,qBAAA;AACF;AACE;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;AACJ;AACI;EACE,kBAAA;EACA,UAAA;AACN;AACM;EACE,kBAAA;AACR;AAGI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,+BAAA;EACA,mBAAA;AADN;;AAQI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;EACA,WAAA;AALN;AASE;EACE,kBAAA;AAPJ","sourcesContent":[".table {\n  border-collapse: separate;\n  border-spacing: 0 5px;\n\n  .tableRow {\n    position: relative;\n    height: 53px;\n    background-color: #fff;\n\n    > td {\n      position: relative;\n      z-index: 1;\n\n      > a {\n        position: relative;\n      }\n    }\n\n    &:after {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      border: 1px solid var(--border);\n      border-radius: 10px;\n    }\n  }\n}\n\n.tableRow2 {\n  > td:first-child {\n    &:before {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      border-radius: 10px;\n      background-color: var(--addition-7);\n      opacity: .05;\n      z-index: -1;\n    }\n  }\n\n  > td > a {\n    position: relative;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `DataTable_table__5hksv`,
	"tableRow": `DataTable_tableRow__PW3q2`,
	"tableRow2": `DataTable_tableRow2__iCh4z`
};
export default ___CSS_LOADER_EXPORT___;
